import { IntlShape } from 'react-intl';

import { TTaxProfile } from '../model/taxProfile';

import { taxProfileMessages } from './messages';

export const getLocalizedTaxProfile = (
  taxProfile: TTaxProfile | null | undefined,
  intl: IntlShape,
): string => (taxProfile ? intl.formatMessage(taxProfileMessages[taxProfile]) : '');
